var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpfulToolSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7951 19.7746C14.113 19.5718 15.5324 19.1663 16.4448 18.2538C17.56 17.1386 18.4724 15.2124 18.4724 13.4826L18.4724 7.59613C18.4724 5.87264 17.56 4.14916 16.4448 3.02763C15.3296 1.91243 13.6061 1 11.8763 1L10.9639 1C9.24037 1 7.51689 1.91243 6.40169 3.02763C5.28016 4.14916 4.36773 5.87264 4.36773 7.59613L4.36773 13.4826",
    stroke: "#1A1A1A",
    strokeWidth: 0.9137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8099 8.8125C14.114 8.8125 14.3168 9.01526 14.3168 9.22436C14.3168 9.52851 14.114 9.73127 13.8099 9.73127C13.6071 9.73127 13.4043 9.52851 13.4043 9.22436C13.4043 9.01526 13.6071 8.8125 13.8099 8.8125ZM9.0386 8.8125C9.24137 8.8125 9.44413 9.01526 9.44413 9.22436C9.44413 9.52851 9.24137 9.73127 9.0386 9.73127C8.73446 9.73127 8.5317 9.52851 8.5317 9.22436C8.5317 9.01526 8.73446 8.8125 9.0386 8.8125Z",
    stroke: "#BA82BA",
    strokeWidth: 0.9137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6755 13.5842C20.2025 13.3815 21.5205 11.9621 21.5205 10.2386C21.5205 8.50882 20.2025 7.08948 18.6755 6.88672M4.16528 13.5842C2.54318 13.3815 1.3266 11.9621 1.3266 10.2386C1.3266 8.50882 2.54318 7.08948 4.16528 6.88672L4.16528 13.5842Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.9137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73423 13.0771C9.03837 14.091 10.0522 14.807 11.3702 14.807C12.6945 14.807 13.8096 14.091 14.1138 13.0771",
    stroke: "#BA82BA",
    strokeWidth: 0.9137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3701 18.4561C12.1812 18.4561 12.7958 19.0643 12.7958 19.8817C12.7958 20.5914 12.1812 21.1997 11.3701 21.1997C10.6604 21.1997 10.0521 20.5914 10.0521 19.8817C10.0521 19.0643 10.6604 18.4561 11.3701 18.4561Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.9137,
    strokeMiterlimit: 22
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26679 7.08886C6.30076 6.68334 8.12562 5.36538 9.03805 3.53418C10.356 4.85847 12.1809 5.66953 14.1135 5.66953C15.4314 5.66953 16.5466 5.36538 17.5604 4.75709",
    stroke: "#1A1A1A",
    strokeWidth: 0.9137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpfulToolSupportIcon);
export default __webpack_public_path__ + "static/media/helpful-tool-support-icon.de39715610ba27873e3891daffdb5b57.svg";
export { ForwardRef as ReactComponent };